import { IdEventV4 } from 'models/event'

import { activeCallDefinition } from './activeCallDefinition'
import { botDetectionDefinition } from './botDetectionDefinition'
import { clonedAppDefinition } from './clonedAppDefinition'
import { developerToolsDefinition } from './developerToolsDefinition'
import { deviceRarityDefinition } from './deviceRarityDefinition'
import { emulatorDefinition } from './emulatorDefinition'
import { factoryResetDefinition } from './factoryResetDefinition'
import { fridaDefinition } from './fridaDefinition'
import { highActivityDefinition } from './highActivityDefinition'
import { incognitoTamperingDefinition } from './incognitoDefinition'
import { ipBlocklistDefinition } from './ipBlocklistDefinition'
import { jailbreakDefinition } from './jailbreakDefinition'
import { locationSpoofingDefinition } from './locationSpoofingDefinition'
import { mitmAttackDefinition } from './mitmAttackDefinition'
import { privacySettingsDefinition } from './privacySettingsDefinition'
import { proxyDefinition } from './proxyDefinition'
import { rootedAppDefinition } from './rootedDefinition'
import { simulatorDefinition } from './simulatorDefinition'
import { tamperingDefinition } from './tamperingDefinition'
import { torDefinition } from './torDefinition'
import { virtualMachineDefinition } from './virtualMachineDefinition'
import { vpnDefinition } from './vpnDefinition'

export const SMART_SIGNAL_DEFINITIONS = [
  botDetectionDefinition,
  vpnDefinition,
  ipBlocklistDefinition,
  proxyDefinition,
  torDefinition,
  highActivityDefinition,
  tamperingDefinition,
  incognitoTamperingDefinition,
  virtualMachineDefinition,
  privacySettingsDefinition,
  developerToolsDefinition,
  emulatorDefinition,
  simulatorDefinition,
  clonedAppDefinition,
  factoryResetDefinition,
  fridaDefinition,
  locationSpoofingDefinition,
  jailbreakDefinition,
  rootedAppDefinition,
  mitmAttackDefinition,
  deviceRarityDefinition,
  activeCallDefinition,
] as const

export function detectedSmartSignals(event?: IdEventV4) {
  return event == null ? [] : SMART_SIGNAL_DEFINITIONS.filter((d) => d.isDetected(event))
}
